import CoreConfigRegistry from './core.config.registry.js';

class CoreConfigManagerSingleton {

    constructor() {
        this.configRegistry = new CoreConfigRegistry();
    }

    retrieveConfig(pluginName, configName = null) {
        return this.configRegistry.getConfig(pluginName, configName);
    }

    storeConfig(pluginName, configName, config) {
        return this.configRegistry.setConfig(pluginName, configName, config);
    }

    deleteConfig(pluginName, configName) {
        return this.configRegistry.deleteConfig(pluginName, configName);
    }

    obtainRegistry() {
        return this.configRegistry;
    }

}

export const CoreConfigManagerInstance = Object.freeze(new CoreConfigManagerSingleton());

export default class CoreConfigManager {

    static retrieve(pluginName, configName = false) {
        return CoreConfigManagerInstance.retrieveConfig(pluginName, configName);
    }

    static store(pluginName, configName, config) {
        return CoreConfigManagerInstance.storeConfig(pluginName, configName, config);
    }

    static delete(pluginName, configName) {
        return CoreConfigManagerInstance.deleteConfig(pluginName, configName);
    }

    static getRegistry() {
        return CoreConfigManagerInstance.obtainRegistry();
    }

}

window.CoreConfigManager = CoreConfigManager;

